import React from "react";
import { UserRound, Medal, TrendingUp, Users } from "lucide-react";
import { usps } from "../mock";

const iconMap = { UserRound, Medal, TrendingUp, Users };
const tones = [
  { bg: "#FEF3C7", ring: "#F59E0B", ic: "#B45309" },
  { bg: "#FCE7F3", ring: "#EC4899", ic: "#BE185D" },
  { bg: "#E0E7FF", ring: "#818CF8", ic: "#4338CA" },
  { bg: "#CFFAFE", ring: "#22D3EE", ic: "#0E7490" },
];

export default function WhyUs() {
  return (
    <section id="why" className="section-light py-20 md:py-28 relative overflow-hidden">
      <div className="blob blob-peach w-72 h-72 -top-20 right-1/4" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">
        <div className="max-w-2xl">
          <div className="text-[#B45309] text-xs font-black tracking-[0.3em] uppercase">Why CYA</div>
          <h2 className="section-title mt-3 text-4xl md:text-5xl font-black brand-navy">
            Built for the <span className="gold-gradient">next generation</span> of achievers.
          </h2>
          <p className="mt-4 text-[#0A1740]/70">
            We combine passionate mentors with practical curriculum so every learner leaves with a real skill – and the confidence to use it.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {usps.map((u, i) => {
            const Icon = iconMap[u.icon];
            const t = tones[i % tones.length];
            return (
              <div
                key={u.title}
                className="group relative rounded-2xl p-6 border border-[#0A1740]/8 bg-white hover:shadow-xl transition-shadow"
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform"
                  style={{ background: t.bg, color: t.ic, border: `1px solid ${t.ring}55` }}
                >
                  <Icon size={22} />
                </div>
                <h3 className="mt-5 text-lg font-extrabold brand-navy">{u.title}</h3>
                <p className="mt-2 text-sm text-[#0A1740]/65 leading-relaxed">{u.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
